export const MOBILE_AGENTS = [/Android/, /webOS/, /iPhone/, /iPad/, /iPod/, /BlackBerry/, /Windows Phone/]

export const INPUT_HIDDEN_NAME = {
  skills: 'expert_profile[skills][]',
  expertises: 'expert_profile[expert_categories][]',
  continent: 'expert_profile[continents_and_countries][continents][]',
  country: 'expert_profile[continents_and_countries][countries][]'
}